// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../roundToNearestMinutes/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var roundToNearestMinutesWithOptions = convertToFP(fn, 2);
export default roundToNearestMinutesWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/roundToNearestMinutesWithOptions/index.js
// module id = 966
// module chunks = 0